import { Center, Spinner } from '@chakra-ui/react'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import { useUniversalState } from '@src/hooks/useUniversalState'
import { usePathname, useRouter } from 'next/navigation'
import React, { createContext, FC, useContext, useEffect } from 'react'

type AccountContextValue = {
  breadcrumbs?: {
    title: string
    href: string
  }[]
  setBreadcrumbs?: (breadcrumbs: AccountContextValue['breadcrumbs']) => void
}

export const AccountContext = createContext<AccountContextValue>({})

export const useAccountContext = () => useContext(AccountContext)

export const AccountContextProvider: FC<AccountContextValue & { children?: React.ReactNode }> = props => {
  const { currentUser } = useCurrentUser()
  const router = useRouter()
  const pathname = usePathname()

  const [breadcrumbs, setBreadcrumbs] = useUniversalState<AccountContextValue['breadcrumbs']>(
    'AccountContext.breadcrumbs',
    props.breadcrumbs || [
      { title: 'Account', href: '/account' },
      { title: 'Overview', href: '/account/overview' },
    ]
  )

  const contextValue = {
    breadcrumbs,
    setBreadcrumbs,
  }

  useEffect(() => {
    if (currentUser?.isGuest) {
      router.push(`/login?returnTo=${pathname?.startsWith('/login') ? '/' : pathname}`)
    }
  }, [currentUser?.isGuest])

  if (!currentUser || currentUser?.isGuest) {
    return (
      <Center padding={'1em'}>
        <Spinner />
      </Center>
    )
  }

  return <AccountContext.Provider value={contextValue}>{props.children}</AccountContext.Provider>
}
